import React, { Component } from 'react';
import { Card, CardContent, Grid, Typography } from "@mui/material";
import defaultImage from "../../../assets/defaultImage.jpg";
import currency from "currency.js";
import { Product } from "../../../classes/types/product/product";
import "./carouselCard.css";
import { Link } from 'react-router-dom';
interface props {
    product: Product;
}

interface state {
}


export default class CarouselCard extends Component<props, state> {
    constructor(props: props) {
        super(props);
        this.state = {

        }
    }

    printPrice = (): any => {
        if (this.props.product.price !== undefined) {
            if (this.props.product.configurable) {
                return <Typography fontSize={16} fontWeight={600}>CONFIGURA ORA</Typography>
            } else {
                return this.props.product.price === undefined ? "" : (this.props.product.discountedPrice !== undefined ? <span><span className={"product-price"}>{currency(this.props.product.price, { symbol: "€" }).format()}</span><span
                    className={'carousel-card-discounted-price'}>{currency(this.props.product.discountedPrice, { symbol: "€" }).format()}</span><br /></span> : <span><span
                        className={'carousel-card-price'}>{currency(this.props.product.price, { symbol: "€" }).format()}</span><br /></span>)
            }
        }
    }

    render() {
        return (
            <Card className={'carousel-card'}><Link to={'/shop/home/prodotto/' + this.props.product.id}>
                <CardContent>
                    <Grid direction={"column"} justifyContent={"space-between"} alignContent={'center'} item container>
                        <Grid className={'carousel-card-image-container'} direction={"row"} xs={12} justifyContent={"center"}
                            item container>
                            <div style={{ overflow: 'hidden', cursor: 'pointer' }}>
                                {<img className={'carousel-card-image-style'} alt={'11ioejw328'} src={this.props.product.images.length > 0 ? this.props.product.images[0].link : defaultImage} />}
                            </div>
                        </Grid>
                        <Grid className={'carousel-card-description-container'} xs={12} item>
                            <span className={"text-overflow2"}>{this.props.product.name}</span>
                            <span className={"text-overflowSku"}>{this.props.product.sku}</span>
                            {this.printPrice()}
                        </Grid>
                    </Grid>
                </CardContent></Link>
            </Card>

        )
    }


}
